var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "boletos__lista" },
    _vm._l(_vm.cobrancas, function(cobranca) {
      return _c(
        "li",
        {
          key: cobranca.Id,
          staticClass: "boletos__lista-item",
          class:
            _vm.financiamentoEstaBloqueado || cobranca.EstaBloqueada
              ? "boletos__lista-item-bloqueado"
              : ""
        },
        [
          _c("MensagemFlutuante", {
            attrs: {
              mensagemVisivel: _vm.mensagemVisivel,
              estilo: _vm.estiloMensagem,
              texto: _vm.textoMensagem
            },
            on: { close: _vm.fecharMensagem }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "boletos__lista-informacoes-principais" }, [
            _vm.podeSelecionarParcelas
              ? _c(
                  "label",
                  {
                    staticClass: "formulario__input-checkbox",
                    attrs: {
                      "aria-label":
                        "Selecionar " + _vm.obterTituloDaCobranca(cobranca)
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.parcelasSelecionadas,
                          expression: "parcelasSelecionadas"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        tabindex: "1",
                        disabled: !cobranca.PodeSerSelecionada
                      },
                      domProps: {
                        value: cobranca,
                        checked: _vm.estaMarcado,
                        checked: Array.isArray(_vm.parcelasSelecionadas)
                          ? _vm._i(_vm.parcelasSelecionadas, cobranca) > -1
                          : _vm.parcelasSelecionadas
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.parcelasSelecionadas,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = cobranca,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.parcelasSelecionadas = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.parcelasSelecionadas = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.parcelasSelecionadas = $$c
                            }
                          },
                          function($event) {
                            return _vm.validarSeCobrancaPossuiRegraDivergente(
                              cobranca,
                              $event
                            )
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "formulario__marcador",
                      class: cobranca.PodeSerSelecionada
                        ? ""
                        : "formulario_input-desabilitado"
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0, true),
            _vm._v(" "),
            _c("div", { staticClass: "boletos__lista-conteudo" }, [
              _c(
                "div",
                { staticClass: "boletos__parcela", attrs: { tabindex: "1" } },
                [
                  _c(
                    "strong",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            cobranca.EstaBloqueada ||
                            _vm.financiamentoEstaBloqueado,
                          expression:
                            "cobranca.EstaBloqueada || financiamentoEstaBloqueado"
                        }
                      ],
                      staticClass: "texto texto_pequeno texto_cor-alerta"
                    },
                    [
                      _c("i", {
                        staticClass:
                          "far fa-lock-alt fa-1x u-margem-direita-mini fa_cor-erro"
                      }),
                      _vm._v("\n            BLOQUEADA\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "boletos__parcela-numero" }, [
                    _vm._v(_vm._s(_vm.obterTituloDaCobranca(cobranca)))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boletos__parcela-vencimento" }, [
                    _vm._v(
                      "Vencimento: " + _vm._s(cobranca.VencimentoFormatado)
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "boletos__valor-do-boleto",
                  attrs: { tabindex: "1" }
                },
                [
                  _c("div", [_vm._v("Valor total da parcela")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boletos__valor-da-parcela" }, [
                    _vm._v(
                      "R$ " +
                        _vm._s(
                          _vm.formatarValorMonetarioParaExibicao(cobranca.Total)
                        )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "botao botao_icone botao_sem-preenchimento ver-composicao-da-parcela",
                  attrs: {
                    type: "button",
                    tabindex: "1",
                    "aria-label":
                      "Mostrar detalhes da " +
                      _vm.obterTituloDaCobranca(cobranca)
                  },
                  on: {
                    click: function($event) {
                      _vm.mostraAba =
                        _vm.mostraAba == cobranca.Id ? "" : cobranca.Id
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.mostraAba == "" || _vm.mostraAba != cobranca.Id,
                          expression:
                            "mostraAba == '' || mostraAba != cobranca.Id"
                        }
                      ]
                    },
                    [_c("i", { staticClass: "fal fa-chevron-down" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mostraAba == cobranca.Id,
                          expression: "mostraAba == cobranca.Id"
                        }
                      ]
                    },
                    [_c("i", { staticClass: "fal fa-chevron-up" })]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostraAba == cobranca.Id,
                  expression: "mostraAba == cobranca.Id"
                }
              ],
              staticClass: "lista-de-boletos__composicao-da-parcela",
              class: _vm.mostraAba ? "classe-que-abre" : "",
              attrs: { tabindex: "1" }
            },
            [
              _c(
                "table",
                {
                  staticClass:
                    "tabela tabela_com-borda tabela_com-largura-total"
                },
                [
                  _c(
                    "caption",
                    {
                      staticClass:
                        "titulo titulo_mini u-texto-alinhado-a-esquerda u-margem-pequena"
                    },
                    [
                      _vm._v(
                        "Composição da " +
                          _vm._s(_vm.obterTituloDaCobranca(cobranca)) +
                          " "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1, true),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          " R$ " +
                            _vm._s(
                              _vm.formatarValorMonetarioParaExibicao(
                                cobranca.Valor
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "R$ " +
                            _vm._s(
                              _vm.formatarValorMonetarioParaExibicao(
                                cobranca.Correcao
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          " R$ " +
                            _vm._s(
                              _vm.formatarValorMonetarioParaExibicao(
                                cobranca.Mora
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "R$ " +
                            _vm._s(
                              _vm.formatarValorMonetarioParaExibicao(
                                cobranca.Multa
                              )
                            )
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boletos__lista-icone" }, [
      _c("i", { staticClass: "fal fa-file-alt" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Valor da Parcela:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de Correção:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de Mora:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor de Multa:")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13aaeaeb", { render: render, staticRenderFns: staticRenderFns })
  }
}